import React, { useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Lessons from "@/components/site/Lessons";
import Schedule from "@/components/site/Schedule";
import Booking from "@/components/site/Booking";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";

export default function Home() {
  const [preset, setPreset] = useState("");

  return (
    <div className="bg-cream" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Lessons onSelect={setPreset} />
        <Schedule />
        <Booking preset={preset} />
        <Gallery />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
